type FormElementWithValue<ValueType> =
  | { value: ValueType }
  | { values: ValueType }
  | { isChecked: ValueType };

type Values<FieldsType extends object> = {
  readonly [Name in keyof FieldsType]: FieldsType extends {
    [key in Name]: FormElementWithValue<infer ValueType>;
  }
    ? ValueType
    : never;
};

export function getFormValues<FieldsType extends object>(fields: FieldsType): Values<FieldsType> {
  return Object.entries(fields).reduce(
    (acc: any, [key, { name, value, current }]: [string, any]) => {
      // useRef - addressAutocomplete - TODO refactor -> hook
      if (current) {
        current.length
          ? current.forEach((item: any) => (acc[item.ident] = item.value))
          : (acc[current.name] = current.values);
      } else {
        if (process.env.NODE_ENV === 'development' && name && key !== name) {
          console.error(`getFormValues field name "${name}" !== key "${key}"`);
        }
        // input, select, multiselect, radio, checkbox
        else {
          acc[key] = value ?? '';
        }
      }
      return acc;
    },
    {},
  );
}
